import { createThemedUseStyles } from "theme";

export default createThemedUseStyles((theme) => ({
  background: {
    backgroundColor: theme.pallette.blue
  },
  outerContainer: {
    display: "flex",
    justifyContent: "center",
    backgroundSize: "cover",
    background: "rgba(0,0,0,0.5)"
  },
  container: {
    maxWidth: theme.maxScreenWidth,
    width: "100%"
  },
  titleBar: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: [[theme.marginScale.large, theme.marginScale.none]],
    color: theme.pallette.foregroundContrast
  },
  title: {
    fontFamily: theme.fontFamilyEmphasis,
    marginRight: theme.marginScale.xlarge,
    whiteSpace: "nowrap"
  },
  items: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  /*
   * The bar must stay a single row. Items never wrap, and if the list is too wide for the
   * container it scrolls horizontally rather than spilling onto a second line and growing
   * the bar's height. minWidth lets this shrink below its content size inside the flex row.
   */
  mainItems: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: 0,
    overflowX: "auto",
    // The bar is short, so a visible scrollbar would itself add height.
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },
  // Keep the unsaved-changes prompt and action buttons at their natural width.
  actionItems: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0
  },
  item: {
    // 8px each side (16px between items) keeps the full item list on one row alongside the
    // unsaved-changes prompt and SAVE button within the container's max width.
    marginRight: theme.marginScale.medium,
    marginLeft: theme.marginScale.medium,
    fontSize: theme.typeScale.small,
    textDecoration: "none",
    whiteSpace: "nowrap",
    color: theme.pallette.lightGray,

    "&:visited": {
      color: theme.pallette.lightGray
    },
    "&:hover": {
      color: theme.pallette.foregroundContrast,
      textDecoration: "underline"
    },
    "&:active": {
      color: theme.pallette.foregroundContrast
    }
  },
  active: {
    textDecoration: "underline",
    fontWeight: "bold"
  }
}));
